import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Menu, Icon } from 'semantic-ui-react';
import BrandLink from './BrandLink';

const MenuAccounting = ({ home = false }) => {
	const accounting = useSelector(state => state.accounting);

	return (
		<div className="main-menu">
			<Menu vertical>
				<BrandLink />
				<h1>{accounting.label}</h1>
				<div className="flex grow flex-column menu-accounting">
					{!home && (
						<>
							<Menu.Item
								as={NavLink}
								to={`/accountings/${accounting.id}`}
								name="balance"
								end
							>
								<div className="flex flex-row align-items-center">
									<Icon name="balance scale" className="inverted" />
									<p>Balance</p>
								</div>
							</Menu.Item>
							<Menu.Item
								as={NavLink}
								to={`/accountings/${accounting.id}/ledger`}
								name="ledger"
							>
								<div className="flex flex-row align-items-center">
									<Icon name="file alternate" className="inverted" />
									<p>Grand Livre</p>
								</div>
							</Menu.Item>
							<Menu.Item
								as={NavLink}
								to={`/accountings/${accounting.id}/journals`}
								name="journals"
							>
								<div className="flex flex-row align-items-center">
									<Icon name="newspaper" className="inverted" />
									<p>Journaux</p>
								</div>
							</Menu.Item>
							<Menu.Item
								as={NavLink}
								to={`/accountings/${accounting.id}/accounts`}
								name="accounts"
							>
								<div className="flex flex-row align-items-center">
									<Icon name="address card" className="inverted" />
									<p>Comptes</p>
								</div>
							</Menu.Item>
							<Menu.Item
								as={NavLink}
								to={`/accountings/${accounting.id}/financial-years`}
								name="financial-years"
							>
								<div className="flex flex-row align-items-center">
									<Icon name="calendar" className="inverted" />
									<p>Exercices</p>
								</div>
							</Menu.Item>
							<Menu.Item
								as={NavLink}
								to={`/accountings/${accounting.id}/reconciliation`}
								name="reconciliation"
							>
								<div className="flex flex-row align-items-center">
									<Icon name="handshake outline" className="inverted" />
									<p>Lettrage</p>
								</div>
							</Menu.Item>
							<Menu.Item
								as={NavLink}
								to={`/accountings/${accounting.id}/income-statement`}
								name="income-statement"
							>
								<div className="flex flex-row align-items-center">
									<Icon name="chart bar" className="inverted" />
									<p>Compte de résultat</p>
								</div>
							</Menu.Item>
							{/* <Menu.Item className="buttoned">
								<ModalCreateEntry handleSuccess={() => {}} />
							</Menu.Item> */}
							<div className="grow" />
							<div className="pt-1 pb-1">
								<Menu.Item
									as={NavLink}
									to={`/accountings`}
									name="accountings"
									className="not-responsive"
									end
								>
									<div className="flex flex-row align-items-center">
										<Icon name="users" className="inverted" />
										<p>Mes Entreprises</p>
									</div>
								</Menu.Item>
							</div>
							<Menu.Item
								as={NavLink}
								to={`/accountings/${accounting.id}/help`}
								name="help"
							>
								<div className="flex flex-row align-items-center">
									<Icon name="question circle" />
									<p>Besoin d'aide ?</p>
								</div>
							</Menu.Item>
						</>
					)}
				</div>
			</Menu>
		</div>
	);
};
export default MenuAccounting;
